import React from 'react';
import Script from 'next/script';

// For development mode:
const DataLayerEmptyScript = () => {
  return (
    <Script id="development">{`window.dataLayer = [];`}</Script>
  );
};

export { DataLayerEmptyScript };